export enum Resizeable {
    both,
    horizontal,
    vertical,
    none
}